import type * as React from 'react';
import Interests from '../../components/Interests/Interests';

function UserInterests(): React.ReactElement {
  return <Interests />;
}

export default UserInterests;
